<template>
  <div>
    <Loading v-if="showWait" />
    <div v-else>
      <PageTitle
        :main="$t('projecao-agricola')"
        sub=""
        imagem="agri.png"
      />
      <HarvestPlanGrid></HarvestPlanGrid>
    </div>
  </div>
</template>

<script>
import PageTitle from "../template/PageTitle";
import HarvestPlanGrid from "./HarvestPlanGrid.vue";
import Loading from "@/components/template/Loading.vue"
import {mapState} from "vuex";

export default {
  name: "HarvestPlan",
  components: { HarvestPlanGrid, PageTitle, Loading },
  computed: mapState(["showWait"]),
  data() {
    return {
      imagem: "",
    };
  },
  watch: {
  },
  beforeCreate(){
    this.$store.commit("setShowWait", true);
  },
  mounted(){
    this.$store.commit("setShowWait", false);
  }
};
</script>

<style scoped>
img {
  max-height: 45px;
}
</style>
